import { Category, DefaultMapping } from '@synergy/models';
import { EditIcon } from '@synergy/theme';
import { IconButton, TableCell, TableRow } from '@mui/material';
import { Localized } from '@synergy/components';
import { makeStyles } from '@mui/styles';
import { padZeroLeft } from '@synergy/utils';
import { useEffect, useState } from 'react';

import { MappedValues } from '../../../../common/components/mapped-values';
import { PaloDisclosureArrow } from '../../../../common/components/palo/palo-disclosure-arrow';

const useStyles = makeStyles(() => ({
    icon: {
        fontSize: 16,
        color: '#21272E',
    },
    content: {
        display: 'flex',
        alignItems: 'center',
        whiteSpace: 'nowrap',
    },
    clickable: {
        cursor: 'pointer',
    },
}));

export interface CategoryMappingRowProps {
    categories: DefaultMapping<Category>[];
    category: DefaultMapping<Category>;
    filterIds?: number[];
    depth: number;
    onEdit: (item: DefaultMapping<Category>) => void;
}

export const CategoryMappingRow = (props: CategoryMappingRowProps) => {
    const classes = useStyles();
    const [isExpanded, setIsExpanded] = useState(false);

    useEffect(() => {
        setIsExpanded(!!props.filterIds);
    }, [props.filterIds]);

    const toggle = () => setIsExpanded(!isExpanded);

    const childCategories = props.categories.filter(category => category.parentId === props.category.id);
    const isExpandable = childCategories.length > 0;
    const indent = props.depth * 48;

    if (props.filterIds && !props.filterIds.includes(props.category.id)) {
        return null;
    }

    return (
        <>
            <TableRow>
                <TableCell
                    onClick={isExpandable ? toggle : undefined}
                    className={isExpandable ? classes.clickable : ''}
                >
                    <div className={classes.content}>
                        <div style={{ width: indent }} />
                        {isExpandable && <PaloDisclosureArrow open={isExpanded} />}
                        <div style={{ width: isExpandable ? 32 : 56 }} />
                        <Localized value={props.category.translations} /> ({padZeroLeft(props.category.id, 3)})
                    </div>
                </TableCell>
                <TableCell>
                    <MappedValues values={props.category.defaultMapping} />
                </TableCell>
                <TableCell>
                    <IconButton onClick={() => props.onEdit(props.category)}>
                        <EditIcon color="primary" style={{ fontSize: 20 }} />
                    </IconButton>
                </TableCell>
            </TableRow>
            {isExpandable &&
                isExpanded &&
                childCategories.map(childCategory => (
                    <CategoryMappingRow
                        key={childCategory.id}
                        categories={props.categories}
                        category={childCategory}
                        filterIds={props.filterIds}
                        onEdit={props.onEdit}
                        depth={props.depth + 1}
                    />
                ))}
        </>
    );
};
